<template>
  <el-select
    v-model="packType"
    :disabled="disabled"
    size="small"
    style="width: 100%;"
    value-key="id"
    @change="onProductPackTypeChange"
  >
    <el-option
      v-for="pack in packTypes"
      :key="pack.id"
      :value="pack"
      :label="pack.pack_type.name"
    >
      {{ pack.pack_type.name }} ({{ pack.count_per_pack }} db / kiszerelés)
      <span
        v-if="isProductSelectFromStock"
        style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px;"
      >
        <el-tag
          size="mini"
          type="info"
        >
          {{ pack.count || 0 }} <span v-if="pack.count_per_pack === 1">db</span><span v-else>{{ pack.pack_type.name }}</span> készleten
        </el-tag>
      </span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    packTypeName: {
      type: String,
      default() {
        return '';
      },
      required: false,
    },
    availablePackTypes: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    defaultPackType: {
      type: Object,
      default() {
        return null;
      },
      required: false,
    },
    isProductSelectFromStock: {
      type: Boolean,
      default() {
        return true;
      },
      required: false,
    },
  },
  data() {
    return {
      packType: {},
      packTypes: [],
    };
  },
  watch: {
    availablePackTypes(packTypes) {
      this.packTypes = packTypes;
      let p = null;
      if (this.packTypeName === 'karton') {
        p = packTypes.find(p => p.pack_type.name === 'karton');
      } else {
        p = packTypes.find(p => p.id === (this.defaultPackType && this.defaultPackType.id));
      }
      this.packType = p || packTypes[0];
      this.onProductPackTypeChange();
    },
  },
  mounted() {
    this.packType = this.defaultPackType;
    this.packTypes = this.availablePackTypes;
  },
  methods: {
    onProductPackTypeChange() {
      this.$emit('change', this.packType);
    },
  },
};
</script>
